/* eslint import/prefer-default-export: 0 */

export const SCOPES = {
  ARTWORKS: 'artworks',
  INCOMING_ARTWORKS: 'incomingArtworks',
};
export const DEFAULT_SEARCH_SCOPE = SCOPES.ARTWORKS;
export const ARTWORKS_FILTERS = {
  AUCTION_HOUSE: {
    PATH: 'activeFilters.artworks.auctionHouse',
    NAME: 'auction_house',
  },
  PRICES: {
    VALUES: {
      STARTING: 'starting',
      ESTIMATION: 'estimation',
      SELLING: 'selling',
    },
    FROM: {
      PATH: 'activeFilters.artworks.price.from',
      NAME: 'price_from',
    },
    TO: {
      PATH: 'activeFilters.artworks.price.to',
      NAME: 'price_to',
    },
    MODES: {
      PATH: 'activeFilters.artworks.price.modes',
      NAME: 'price_modes',
    },
  },
  DATES: {
    FROM: {
      PATH: 'activeFilters.artworks.date.from',
      NAME: 'date_from',
    },
    TO: {
      PATH: 'activeFilters.artworks.date.to',
      NAME: 'date_to',
    },
  },
  CATEGORIES: {
    PATH: 'activeFilters.artworks.categories',
    NAME: 'categories',
  },
  STATES: {
    VALUES: {
      SOLD: 'sold',
      SOLD_CONDITIONALLY: 'sold_conditionally',
      UNSOLD: 'unsold',
      ALL: 'all',
    },
    PATH: 'activeFilters.artworks.states',
    NAME: 'states',
  },
  CATALOG_NUMBERS: {
    PATH: 'activeFilters.artworks.catalogNumbers',
    NAME: 'catalog_numbers',
  },
  ARTIST: {
    PATH: 'activeFilters.artworks.artist.id',
    NAME: 'artist',
  },
};
export const LIVE_TYPE = 'live';
export const HAMMER_TYPE = 'hammer';
export const CATALOG_IN_PROGRESS = 'in_progress';
export const FINISHED_AUCTIONS_CATALOG_STATE = 'finished';
export const UNPUBLISHED_CATALOG_VALUE = 'unpublished';
export const EMPTY_ARTWORKS_FILTER_STATE = {
  catalogNumbers: '',
  auctionHouse: '',
  price: {
    modes: [],
    from: null,
    to: null,
  },
  date: {
    from: null,
    to: null,
  },
  categories: [],
  states: [],
  artist: {},
};
export const QUERY_PARAMS_NAMES_FOR_ARTWORKS_FILTERS = [
  'house', 'prices_modes', 'price_to', 'price_from',
  'date_from', 'date_to', 'categories', 'states', 'artist',
];
export const ARTWORKS_FILTERS_FROM_PANEL_ARRAY = [
  ARTWORKS_FILTERS.AUCTION_HOUSE,
  ARTWORKS_FILTERS.PRICES.FROM,
  ARTWORKS_FILTERS.PRICES.TO,
  ARTWORKS_FILTERS.PRICES.MODES,
  ARTWORKS_FILTERS.CATEGORIES,
  ARTWORKS_FILTERS.STATES,
  ARTWORKS_FILTERS.DATES.FROM,
  ARTWORKS_FILTERS.DATES.TO,
  ARTWORKS_FILTERS.ARTIST,
];
export const MAIN_QUERY_PARAM_NAME = 'main_query';
export const SORT_PARAM_NAME = 'sort';
export const SORTING = {
  ARTWORKS: {
    PATH: 'sorting.artworks',
    VALUES: {
      RELEVANCE: 'relevance',
      DATE_ASC: 'date_asc',
      DATE_DESC: 'date_desc',
      SELLING_PRICE_DESC: 'selling_price_desc',
      UNIFIED_INITIAL_PRICE_DESC: 'unified_initial_price_desc',
    },
    DEFAULT_VALUE: 'date_desc',
  },
};
export const DATEPICKER_LANG = {
  days: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
  months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec',
    'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
  placeholder: {
    date: 'Wybierz datę',
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/search_page/index/consts.js